export default __webpack_public_path__ + "static/media/09.555f4acd.jpg";